import { DeliveryStatus } from "../components/app/app";

export const filterClosed = (records: DeliveryStatus[], showClosed: boolean) =>
  records.filter((r) => (showClosed ? r : !r.closed));
